import axios from 'axios';
import BASEURL from '../utils/BASEURL';

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

const privateAxios = axios.create({
  baseURL: BASEURL,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
});

export default privateAxios;
